// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Offer_tooltip__0_Hgv","tooltip_text":"Offer_tooltip_text__9YDoq"};